import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import Delicious from "./Delicious";
import MenuCard, { CategoryBubble } from "./MenuCard";
import { categories, defaultKey } from "../utils/menuData";

// home page shows a preview; the full list lives on /menu
const PREVIEW_COUNT = 8;

/* ----------------------------
   Component
----------------------------- */
const FoodMenu = () => {
  const [activeKey, setActiveKey] = useState(defaultKey);
  const activeCategory = categories.find((c) => c.id === activeKey) || categories[0];
  const activeItems = activeCategory?.items || [];
  const fullMenuLink = `/menu/${encodeURIComponent(activeCategory?.id || "")}`;

  return (
    <section className="bg-[#FAF8F5] py-12" id="target-section">
      <div className="mx-auto max-w-6xl px-4">
        {/* Heading */}
        <div className="mb-6 flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-sm text-gray-500">Popular Menu</p>
            <Delicious />
            <div className="mt-2 w-20 border-b-4 border-green-500" />
          </div>
          <Link
            to="/menu"
            className="inline-flex w-fit items-center gap-1 text-sm font-semibold text-green-700 hover:text-green-800"
          >
            Full menu <FiArrowRight className="h-4 w-4" />
          </Link>
        </div>

        {/* Shop by category */}
        <div className="no-scrollbar -mx-4 flex gap-3 overflow-x-auto px-4 pb-2 pt-1 md:gap-5">
          {categories.map((cat) => (
            <CategoryBubble key={cat.id} cat={cat} active={activeKey === cat.id} onClick={() => setActiveKey(cat.id)} />
          ))}
        </div>

        {/* Items */}
        <div className="mb-4 mt-6 flex items-baseline justify-between gap-4">
          <h3 className="text-lg font-bold text-gray-900 md:text-xl">{activeCategory?.name}</h3>
          <span className="text-xs text-gray-500 md:text-sm">{activeItems.length} items</span>
        </div>
        {activeItems.length === 0 ? (
          <div className="rounded-2xl bg-white p-8 text-center text-sm text-gray-500">No items found for this category.</div>
        ) : (
          <div className="grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-4 lg:grid-cols-4">
            {activeItems.slice(0, PREVIEW_COUNT).map((item, idx) => (
              <MenuCard key={item.id || idx} item={item} category={activeCategory} activeKey={activeKey} />
            ))}
          </div>
        )}

        {activeItems.length > PREVIEW_COUNT && (
          <div className="mt-6 flex justify-center">
            <Link
              to={fullMenuLink}
              state={{ activeKey: activeCategory?.id }}
              className="inline-flex items-center gap-2 rounded-full bg-gray-900 px-6 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-green-600"
            >
              View all {activeItems.length} in {activeCategory?.name} <FiArrowRight className="h-4 w-4" />
            </Link>
          </div>
        )}
      </div>
    </section>
  );
};

export default FoodMenu;
